"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BillingEntity_1 = __importDefault(require("./Entity/BillingEntity"));
var BillingApi = /** @class */ (function () {
    function BillingApi(session) {
        this.billingEntity = new BillingEntity_1.default(session);
    }
    BillingApi.prototype.getTasks = function (queryString) {
        return this.billingEntity.getAllTasks(queryString);
    };
    BillingApi.prototype.getOrders = function (payload) {
        return this.billingEntity.getOrders(payload);
    };
    BillingApi.prototype.getAggregatedTasks = function (queryString) {
        return this.billingEntity.getAggregatedTasks(queryString);
    };
    BillingApi.prototype.getAggregatedTasksV2 = function (payload) {
        return this.billingEntity.getAggregatedTasksV2(payload);
    };
    BillingApi.prototype.getRefunds = function (payload) {
        return this.billingEntity.getRefunds(payload);
    };
    BillingApi.prototype.getOrdersReport = function (payload) {
        return this.billingEntity.getOrdersReport(payload);
    };
    BillingApi.prototype.getRefundsReport = function (payload) {
        return this.billingEntity.getRefundsReport(payload);
    };
    BillingApi.prototype.getAggregatedByDaysTasksV2 = function (payload) {
        return this.billingEntity.getAggregatedByDaysTasksV2(payload);
    };
    BillingApi.prototype.getFleets = function (queryString) {
        return this.billingEntity.getAllFleets(queryString);
    };
    BillingApi.prototype.getTeams = function (queryString) {
        return this.billingEntity.getAllTeams(queryString);
    };
    BillingApi.prototype.getFleetsV3 = function (payload) {
        return this.billingEntity.getAllFleetsV3(payload);
    };
    BillingApi.prototype.getTeamsV3 = function (payload) {
        return this.billingEntity.getAllTeamsV3(payload);
    };
    BillingApi.prototype.postDispute = function (payload) {
        return this.billingEntity.postDispute(payload);
    };
    BillingApi.prototype.getDisputesByTaskIds = function (payload) {
        return this.billingEntity.getDisputesByTaskIds(payload);
    };
    return BillingApi;
}());
exports.default = BillingApi;
//# sourceMappingURL=BillingApi.js.map